/**
 * Simple debounce function.
 *
 * @see https://gist.github.com/simonw/c29de00c20fde731243cbac8568a3d7f
 * @param {Function} fn
 * @param {Number} delay
 * @returns {Function}
 */
export default (fn, delay) => {
  let timer = null;
  return (...args) => {
    const context = this;
    timer && clearTimeout(timer); // eslint-disable-line
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
};
